// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fdd5a7 {
  line-height: 1.2;
  font-size: 1.25rem;
  text-decoration: none;
  font-family: "HM Sans Regular", "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", Osaka, "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif;
  font-weight: 400;
  text-transform: none;
  color: inherit;
}

@media screen and (min-width: 768px) {
  .fdd5a7 {
    line-height: 1.25;
      font-size: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/@hm-group/fabric-components/dist/esm/brand/hm/components/Typography/navigation/NavigationLarge/NavigationLarge.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,wIAAwI;EACxI,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE;IACE,iBAAiB;MACf,eAAe;EACnB;AACF","sourcesContent":[".fdd5a7 {\n  line-height: 1.2;\n  font-size: 1.25rem;\n  text-decoration: none;\n  font-family: \"HM Sans Regular\", \"ヒラギノ角ゴ Pro W3\", \"Hiragino Kaku Gothic Pro\", Osaka, \"メイリオ\", Meiryo, \"ＭＳ Ｐゴシック\", \"MS PGothic\", sans-serif;\n  font-weight: 400;\n  text-transform: none;\n  color: inherit;\n}\n\n@media screen and (min-width: 768px) {\n  .fdd5a7 {\n    line-height: 1.25;\n      font-size: 1rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
